{
	"_lang": "it",
	"archive": {
		 "playlists": "Eartunes",
		 "userPlaylists": "Le mie playlist",
		 "radio": "Eartunes Radio",
		 "archive": "Music Archive"
	},
	"btn": {
		"save": "Salva",
		"delete": "Cancella",
		"mkdir": "Nuova cartella",
		"ok": "Ok",
		"cancel": "Annulla"
	},
	"deletePl": {
		"title": "Cancella playlist",
		"prompt": "Vuoi veramente cancellare la playlist:"
	},
	"deleteFolder": {
		"title": "Cancella cartella",
		"prompt": "Vuoi veramente cancellare la cartella:"
	},
	"list": {
		"archive": "Archivio",
		"artist": "Artista",
		"title": "Titolo",
		"duration": "Lunghezza"
	},
	"~login": {
		"title": "Login",
		"user": "User:",
		"password": "Password:",
		"btn": "Login",
		"error": "Login failed"
	},
	"mkdir": {
		"title": "Nuova cartella",
		"prompt": "Inserisci un nuovo nome per la cartella"
	},
	"savePlaylist": {
		"title": "Salva playlist",
		"prompt": "Inserisci un nuovo nome per la playlist"
	},
	"scheduler": {
		"~edit": "Edit",
		"any": "Ogni",
		"all": "Tutti",
		"none": "Nessuno",
		"add": "Nuovo",
		"delete": "Cancella",
		"enabled": "Abilitato",
		"weekdays": "Giorni della settimana",
		"startTime": "Orario",
		"endTime": "Fine",
		"pls": "Playlist",
		"frequency": "Frequenza",
		"startDate": "Data inizio",
		"endDate": "Data fine",
		"mode": "Modalità",
		"players": "Player",
		"jingles": "Jingles",
		"volume": "Volume",
		"keepVolume": "Mantieni",
		"days": ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"],
		"~editTitle": {
			"_": "edit scheduler",
			"date": "edit date",
			"jingles": "edit jingles",
			"interval": "edit interval",
			"mode": "edit mode",
			"players": "edit players",
			"playlists": "edit playlists",
			"time": "edit time",
			"volume": "edit volume",
			"weekdays": "edit week days"
		},
		"modes": {
			"playOne": "Suona uno",
			"playInOrder": "Suona in ordine",
			"playNow": "Suona subito",
			"disabled": "Disabilita"
		}
	},
	"settings": {
		"~editSoundcard": "edit sound card"
	},
	"~conn": {
		"lost": "connection lost",
		"reconnecting": "connecting..."
	},
	"~users": {
		"title": "Web Users",
		"new": "New User",
		"delete": "Cancella",
		"name": "Nome",
		"pwd": "Password",
		"pwdConfirm": "Confirm",
		"group": "Group",
		"players": "Player",
		"btnCreate": "Create",
		"plDir": {
			"_": "Playlist Folder",
			"title": "Select Playlist Folder",
			"prompt": "The new user will only see playlists inside of the selected directory"
		}
	}
}
